<div class="container not-found-wrapper d-flex flex-column align-items-center justify-content-center text-center py-5">
  <img [src]="imgSrc" alt="Page Not Found" class="not-found-img mb-4" />

  <h1 class="not-found-title mb-3">Page Not Found</h1>
  <p class="not-found-text mb-4">
    The page you’re looking for doesn’t exist or has been moved.
  </p>

  <a class="not-found-btn" routerLink="/">Back to Home</a>
</div>
